import { IStatisticsItem } from 'widgets/Roulette/types';

export enum ACTIONS {
  SET_HOT_COLD_ANALYTICS = 'SET_HOT_COLD_ANALYTICS',
}

export interface IHotColdAnalytics {
  hotColdAnalytics: IStatisticsItem[];
}
